
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsafd550353c84a6a23e27584b385231bfen from './en.yaml'
            i18n.addResourceBundle('en', 'afd550353c84a6a23e27584b385231bf', flattenObject(nsafd550353c84a6a23e27584b385231bfen), true, true);
        
        export default 'afd550353c84a6a23e27584b385231bf';
    